import { RESPONSE_TYPES } from '@namespace/ssr/src/constants';
import { getDeviceIdHeaderSetter } from '../../services/fingerprint';
import { FetchOptions } from '../../types/utils';
import isomorphicFetch from '../isomorphicFetch';

export const getResourceFromCms = async <T>(
  param: string,
  { isSSR = false, headers, logger, timeout }: FetchOptions = {}
): Promise<T> => {
  const path = `${isSSR ? '' : `/adm-gw01`}/public${param}`;

  const setDeviceIdHeader = await getDeviceIdHeaderSetter();
  const newHeaders = setDeviceIdHeader(headers);

  let timeoutId: NodeJS.Timeout;
  let signal;
  let controller: AbortController;
  if (timeout) {
    controller = new AbortController();
    ({ signal } = controller);
    timeoutId = setTimeout(() => {
      controller.abort('Response timed out.');
    }, timeout);
  }

  return isomorphicFetch(path, { headers: newHeaders, signal }, logger)
    .then((response) => {
      clearTimeout(timeoutId);

      const { url, ok, status } = response;
      if (!ok) {
        throw new Error(`http error - status: ${status}, url: ${url}`);
      }

      return response.json();
    })
    .catch((error) => {
      logger?.error(
        `Error loading at url: "${path}". Response type: ${RESPONSE_TYPES.GET_RESOURCE_FROM_CMS_ERROR}`
      );

      throw new Error(error);
    });
};
